import React from 'react';
import { JobDetailViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: JobDetailViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
